import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { SponsorSubject } from '../sponsor-subject';
import { map } from 'rxjs/operators';

@Injectable()
export class SponsorSelectedSubjectRouteData {
    public readonly subject: Observable<SponsorSubject>;

    constructor(activatedRoute: ActivatedRoute) {
        this.subject = activatedRoute.data.pipe(
            map(x => x['selectedSubject'] as SponsorSubject)
        );
    }
}